// extracted by mini-css-extract-plugin
export default {"Dropdown-menu":"NoAccessPanel_Dropdown-menu__DKXus","container":"NoAccessPanel_container__ksQfd","bgr":"NoAccessPanel_bgr__AEGsi","inner":"NoAccessPanel_inner__5csJx"};